import {Link} from "@aws-amplify/ui-react";
import React from "react";

const EiaLink = function(props) {

    const {name, link, isExternal=false} = props;

    return <Link
        key={name}
        color="#F4D03F"
        href={link}
        isExternal={isExternal}
    >
        {name}
    </Link>
};
export default EiaLink;

